var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 11.333V7.33301L4.66669 8.66634",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33301L7.33333 8.66634",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 6.66732V10.0007C14.6666 13.334 13.3333 14.6673 9.99998 14.6673H5.99998C2.66665 14.6673 1.33331 13.334 1.33331 10.0007V6.00065C1.33331 2.66732 2.66665 1.33398 5.99998 1.33398H9.33331",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 6.66732H12C9.99998 6.66732 9.33331 6.00065 9.33331 4.00065V1.33398L14.6666 6.66732Z",
    stroke: "#A3A3A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportOrders);
export default __webpack_public_path__ + "static/media/export-orders.3feb5ac7cb20ba46628dbb5993940c9a.svg";
export { ForwardRef as ReactComponent };